import React from 'react';

function ServicesSection() {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: '500px'}}>
          <h1 className="display-6 mb-5">Climatización Industrial Precisión y Rendimiento para tu Producción</h1>
        </div>
        <div className="row g-4 justify-content-center">
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item">
              <img className="img-fluid" src="/img/aireIndustrial.jpeg" alt="" />
              <div className="d-flex align-items-center bg-light">
                <div className="service-icon flex-shrink-0 bg-primary">
                  <img className="img-fluid" src="/img/icon/icon-01-light.png" alt="" />
                </div>
                <a className="h4 mx-4 mb-0" href="#">Sistemas de Climatización</a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item">
              <img className="img-fluid" src="/img/reparacion.jpeg" alt="" />
              <div className="d-flex align-items-center bg-light">
                <div className="service-icon flex-shrink-0 bg-primary">
                  <img className="img-fluid" src="/img/icon/icon-02-light.png" alt="" />
                </div>
                <a className="h4 mx-4 mb-0" href="#">Mantenimiento y Reparación</a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item">
              <img className="img-fluid" src="/img/proyectos.jpeg" alt="" />
              <div className="d-flex align-items-center bg-light">
                <div className="service-icon flex-shrink-0 bg-primary">
                  <img className="img-fluid" src="/img/icon/icon-03-light.png" alt="" />
                </div>
                <a className="h4 mx-4 mb-0" href="#">Diseño de Proyectos</a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item">
              <img className="img-fluid" src="/img/service-4.jpg" alt="" />
              <div className="d-flex align-items-center bg-light">
                <div className="service-icon flex-shrink-0 bg-primary">
                  <img className="img-fluid" src="/img/icon/icon-04-light.png" alt="" />
                </div>
                <a className="h4 mx-4 mb-0" href="#">Climatización Industrial y de Procesos</a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item">
              <img className="img-fluid" src="/img/service-5.jpg" alt="" />
              <div className="d-flex align-items-center bg-light">
                <div className="service-icon flex-shrink-0 bg-primary">
                  <img className="img-fluid" src="/img/icon/icon-05-light.png" alt="" />
                </div>
                <a className="h4 mx-4 mb-0" href="#">Sistemas de Ventilación y Calidad de Aire</a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item">
              <img className="img-fluid" src="/img/service-6.jpg" alt="" />
              <div className="d-flex align-items-center bg-light">
                <div className="service-icon flex-shrink-0 bg-primary">
                  <img className="img-fluid" src="/img/icon/icon-06-light.png" alt="" />
                </div>
                <a className="h4 mx-4 mb-0" href="#">Asistencia Técnica de Urgencia 24/7</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicesSection;